import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgConcert(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M4.96 12.074L11.2 5.88a4.052 4.052 0 001.05 1.81c.46.455 1.002.773 1.577.967l.247.076-6.24 6.194-.67-.665L5.414 16 4 14.596l1.75-1.737-.79-.785L11.2 5.88zM12.584 1.58a7.23 7.23 0 002.003 3.793 7.314 7.314 0 003.822 1.988c-1.635 1.282-4.007 1.193-5.516-.306a4.1 4.1 0 01-.31-5.475zm6.203-.375a4.105 4.105 0 01.408 5.355 6.435 6.435 0 01-3.964-1.826A6.339 6.339 0 0113.39.8c1.63-1.182 3.924-1.057 5.396.405z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Concert')(SvgConcert);
